import Vue from "vue";
import App from "./App.vue";
import router from "@/route";
// import ElementUI from 'element-ui'
import "element-ui/lib/theme-chalk/index.css";
import element from "./assets/element/index";
// import XEUtils from 'xe-utils'
import axios from "axios";
import store from "./store/store";
import moment from "moment";
// import * as echarts from 'echarts';
import { IBMS_API } from "./api/config";
import Cookies from "js-cookie";
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
// import 'xe-utils'

// import VXETable from 'vxe-table'
// import 'vxe-table/lib/style.css'
import func from "./tools/func";
// import { Page } from 'view-design';

Vue.use(func);
import Mixin from "./mixins/index";
/*element.Dialog.props.lockScroll.default = false;*/
Vue.mixin(Mixin);

// import {
//     PieChart
// } from 'echarts/charts';
// // 引入提示框，标题，直角坐标系组件，组件后缀都为 Component
// import {
//     TitleComponent,
//     TooltipComponent,
//     GridComponent
// } from 'echarts/components';
// // 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
// import {
//     CanvasRenderer
// } from 'echarts/renderers';
// // 注册必须的组件
// echarts.use(
//     [TitleComponent, TooltipComponent, GridComponent, PieChart, CanvasRenderer]
// );

import {
  //   Header,
  Column,
  Table,
  // Grid,
  // Button,
} from "vxe-table";
// import zhCN from 'vxe-table/lib/locale/lang/zh-CN'

// Vue.prototype.$echarts = echarts;
Vue.prototype.moment = moment;
Vue.prototype.$axios = axios;
// Vue.use(ElementUI);
Vue.use(element);
// Vue.use(vxe_table)
Vue.use(ViewUI);
// Vue.use(VXETable)
Vue.config.productionTip = false;
Vue.prototype.IBMS_API = IBMS_API;
Vue.prototype.Cookies = Cookies;
axios.defaults.withCredentials = true;
Vue.prototype.$axios.defaults.headers.common["x-csrftoken"] = `DP`;
Vue.prototype.$axios.defaults.headers.common[
  "Authorization"
] = `${store.state.auth_key}`;

// 按需加载的方式默认是不带国际化的，需要自行导入
// VXETable.setup({
//   // 使用 vue-i18n 解析占位符 '{xx}'
//   //i18n: (key, args) => i18n.t(key, args),
//   // 使用 xe-utils 解析占位符 '{xx}'
//   i18n: (key, args) => XEUtils.toFormatString(XEUtils.get(zhCN, key), args)
// })

// 按需导入依赖的模块

// Vue.use(Header)
Vue.use(Column);
// 导入表格
Vue.use(Table);
// Vue.use(Grid);
// Vue.use(Button);

// Vue.component('Page', Page);
// Vue.component('Table', Table2);
// Vue.component('Table', Table);

axios.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    // console.log(router.currentRoute.path)
    if (
      router.currentRoute.path !== "/login" &&
      response.data.result === 8888
    ) {
      Vue.prototype.$message({
        message: "登录信息已过期，请重新登录",
        type: "warning",
      });
      router.push("/");
      return response;
      // return Promise.reject(response);
    } else {
      return Promise.resolve(response);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'

new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>",
  render: (h) => h(App),
});
